import ShogiApp from './components/ShogiApp';
import './App.css';

function App() {
  return <ShogiApp />;
}

export default App;